import React from 'react';

import { getClientNavigationLink } from '@/utils/post/utils';

interface RedirectLinkProps {
  to: string;
  children: React.ReactNode;
  replace?: boolean;
  className?: string;
  [key: string]: any;
}

const RedirectLink: React.FC<RedirectLinkProps> = ({
  to,
  children,
  replace = false,
  className,
  ...props
}: RedirectLinkProps) => {
  const [showPrefetch, setShowPrefetch] = React.useState(false);

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    // Window checks are due to SSR
    if (replace) {
      if (window?.history) {
        window.history.replaceState({}, '', to);
      }
    } else {
      if (window?.history) {
        window.history.pushState({}, '', to);
      }
    }

    if (window?.dispatchEvent) {
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  };

  return (
    <>
      <a
        href={to}
        className={className}
        onClick={handleClick}
        {...props}
        onMouseEnter={() => setShowPrefetch(true)}
        onMouseLeave={() => setShowPrefetch(false)}
      >
        {children}
      </a>
      {showPrefetch && <link rel="prefetch" href={getClientNavigationLink(to)} />}
    </>
  );
};

export default RedirectLink;
